import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";
import StateProvince from "domain/stateProvince";
import geoService from "./geoService";

export class StateProvincesLoaded extends Event {
  constructor(public states: StateProvince[]) {
    super(StateProvincesLoaded.EventName);
  }

  public static EventName: string = "states/loaded";
}



export function loadStateProvinces(): ActionWithDispatch<StateProvince[]> {
  return function(dispatch: any) {
    return geoService
      .listStateProvinces()
      .then(states => dispatch(new StateProvincesLoaded(states).toObject()));
  };
}

